import { Upload } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React, { useCallback, useRef, useState } from 'react';
import { handleFiles } from "../../helper/functions/handleFiles.js";
import styles from "./DropZone.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DropZone({
  onDrop,
  onDragEnter,
  onDragLeave,
  name,
  description,
  variant = 'white',
  className,
  disableOverlay,
  children
}) {
  const [isDragging, setIsDragging] = useState(false);
  // Counter to track nested drag events, ensures proper drag state handling when dragging over child elements
  const dragCounter = useRef(0);
  const handleDragOver = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  const handleDragEnter = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current += 1;
    setIsDragging(true);
    onDragEnter?.();
  }, [onDragEnter]);
  const handleDragLeave = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current -= 1;
    if (dragCounter.current === 0) {
      setIsDragging(false);
      onDragLeave?.();
    }
  }, [onDragLeave]);
  const handleDrop = useCallback(async e => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current = 0;
    setIsDragging(false);
    onDragLeave?.();
    await handleFiles(e.dataTransfer.files, onDrop);
  }, [onDrop, onDragLeave]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
    children: [children, /*#__PURE__*/_jsx("div", {
      className: classNames(styles.dropZoneOverlay, className, {
        [styles.dragging]: isDragging && !disableOverlay
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: classNames(styles.content, styles[variant]),
        children: [/*#__PURE__*/_jsx(Upload, {
          size: 20,
          className: styles.icon
        }), /*#__PURE__*/_jsx("p", {
          className: styles.name,
          children: name
        }), description && /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: description
        })]
      })
    })]
  });
}